import { render, staticRenderFns } from "./FactorialMaterialImportList.vue?vue&type=template&id=3488be45&scoped=true"
import script from "./FactorialMaterialImportList.vue?vue&type=script&lang=js"
export * from "./FactorialMaterialImportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3488be45",
  null
  
)

export default component.exports